import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { specialtyColor } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CrmRecordChipHeader = ({
  title,
  icon,
  textDecoration
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "200",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(IconCircle, {
      backgroundColor: specialtyColor('breeze-icon-primary-default'),
      borderColor: specialtyColor('breeze-border-tertiary-default'),
      borderWidth: "100",
      borderStyle: "solid",
      color: specialtyColor('breeze-icon-icon-button-default'),
      icon: icon
    }), /*#__PURE__*/_jsx(Flex, {
      gap: "50",
      flexDirection: "column",
      justifyContent: "center",
      children: title && /*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        textDecoration: textDecoration !== null && textDecoration !== void 0 ? textDecoration : 'none',
        textAlign: "left",
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: title
        })
      })
    })]
  });
};